<template>
  <header class="ca-header" :style="{ background: nav.bgColor || '#333' }">
    <div class="ca-header__inner">
      <div class="ca-header__left">
        <!-- 原型口径：logo 与平台名并排展示（不是互斥）；
             logo 无数据或加载失败时不占位，平台名照常显示 -->
        <img
          v-if="nav.logoFileId && !logoError"
          class="ca-header__logo"
          :src="'/zcjf/base/file/download/' + nav.logoFileId"
          :style="{ cursor: nav.website ? 'pointer' : 'default' }"
          @click="handleLogoClick"
          @error="logoError = true"
        />
        <span v-if="nav.sysName" class="ca-header__brand">{{ nav.sysName }}</span>
        <!-- 分隔线 + 二级标题「CA在线申请」仅申请页展示，其他页面只有品牌区 -->
        <span v-if="hasBrand && isApplyPage" class="ca-header__divider" />
        <span v-if="isApplyPage" class="ca-header__subtitle">CA在线申请</span>
      </div>
      <div class="ca-header__right">
        <el-button v-if="!isLogin" size="small" class="ca-header__login-btn" @click="handleLogin">
          立即登录
        </el-button>
        <el-dropdown v-else trigger="click" @command="handleCommand">
          <span class="ca-header__mobile">
            {{ mobile }}<i class="el-icon-arrow-down" />
          </span>
          <!-- :append-to-body="false"：菜单面板留在组件 DOM 内（默认挂 body 样式不可控），
               hover 主题红才能用下面的 scoped 样式覆盖 -->
          <el-dropdown-menu slot="dropdown" :append-to-body="false" class="ca-header__menu">
            <el-dropdown-item command="profile">个人中心</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import { showLogin } from '@/shared/user'
import { resolveCustomerCodeByHost } from '@/util/domainMap'
import { resolveCaEntryTarget } from '../util/caGuard'

export default {
  name: 'CaHeader',
  props: {
    nav: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { logoError: false }
  },
  computed: {
    // 登录态（store 里 name 即用户手机号，getter 为空串 = 未登录）
    isLogin() {
      return !!this.$store.getters.name
    },
    // 顶栏展示的手机号（产品明确要求不脱敏，展示完整号码）
    mobile() {
      return this.$store.getters.name
    },
    // 左侧是否有品牌内容（logo 或文字品牌名）：有才展示其与副标题间的分隔线
    hasBrand() {
      return (this.nav.logoFileId && !this.logoError) || this.nav.sysName
    },
    // 二级标题「CA在线申请」只在申请页展示（原型口径），订单/详情/联系等页不展示
    isApplyPage() {
      return this.$route.name === 'ca-apply'
    },
  },
  watch: {
    // 换客户后 logo 地址变了，重置失败标记重新尝试加载
    'nav.logoFileId'() {
      this.logoError = false
    },
  },
  methods: {
    handleLogoClick() {
      // 客户配置了官网才允许点击跳转，否则 logo 只是张图
      if (this.nav.website) window.open(this.nav.website)
    },
    handleLogin() {
      showLogin()
    },
    handleCommand(cmd) {
      if (cmd === 'profile') {
        this.$router.push({ name: 'ca-orders' })
      } else if (cmd === 'logout') {
        this.handleLogout()
      }
    },
    /**
     * 退出后回到「本客户的申请页」而不是主站首页：客户编码留在 store 里不清，
     * 本地 / 联调环境（域名解析不出编码）跳转时额外附 ?code 作双保险。
     */
    handleLogout() {
      const code = this.$store.state.ca.customerCode
      const hostCode = resolveCustomerCodeByHost(window.location.hostname)
      const target = resolveCaEntryTarget(hostCode, code)
      this.$store
        .dispatch('user/logout')
        .catch(() => {
          this.$store.commit('user/SET_USER', '')
          this.$store.dispatch('user/resetToken')
        })
        .then(() => this.$router.replace(target))
    },
  },
}
</script>
